import { logout } from 'src/core/services/logout'

const auth = {
  ACCESS_TOKEN: 'ACCESS_TOKEN',

  setAccessToken(accessToken: string): void {
    window.localStorage.setItem(this.ACCESS_TOKEN, accessToken)
  },

  removeAccessToken(): void {
    window.localStorage.removeItem(this.ACCESS_TOKEN)
  },

  getAccessToken(): string | null {
    return window.localStorage.getItem(this.ACCESS_TOKEN)
  },

  logOut(): void {
    logout()
    this.removeAccessToken()
    for (let key in window.localStorage) {
      if (key !== 'language') {
        window.localStorage.removeItem(key)
      }
    }
    window.location.href = '/'
  },

  isAuthenticated(): boolean {
    const accessToken = this.getAccessToken()
    return typeof accessToken === 'string' && accessToken.length > 0
  },

  getPermissions(permissionName: string): boolean {
    const permissions: string[] = JSON.parse(window.localStorage.getItem('permissions') as string)

    if (!permissions) return false

    return permissions.includes(permissionName)
  },
}

export default auth
